module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.3627/img/screenshot-twitter.png"